var map = {
	"./If": 4,
	"./If.js": 4,
	"./my_subdirectory/HelloWorld": 6,
	"./my_subdirectory/HelloWorld.js": 6,
	"./notes/Notes": 7,
	"./notes/Notes.js": 7,
	"./notes/NotesTwo": 8,
	"./notes/NotesTwo.js": 8,
	"./tasks/Tasks": 9,
	"./tasks/Tasks.js": 9
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;